<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <div class="icon-help">
          <div class="detail">
            <div class="detail-box">
              <h4>1. 什么是学习积分？</h4>
              <div class="con uc-pt5">
                积分是社区建设的计分体系。
              </div>
              <h4>2. 学习积分的用途？</h4>
              <div class="con uc-pt5">
                您可以用学习积分可以在积分商城兑换商品。请大家关注积分商城。
              </div>
              <h4>3. 如何获得积分？</h4>
              <div class="con">
                <div
                  class="uc-pt5"
                  v-for="(item, index) in ruleList"
                  :key="index"
                >
                  <p>{{ index + 1 }}） {{ item.name }}</p>
                  <p>
                    {{ item.description }}
                    <!-- <span class="uc-ml20">加{{ item.score }}分</span> -->
                  </p>
                </div>
              </div>
              <h4>4. 如何查询我的学习积分？</h4>
              <div class="con uc-pt5">
                在 个人中心 - 我的积分 中查询积分明细。
              </div>
              <h4>5. 最终解释权归ITS学习中心所有。</h4>
            </div>
          </div>
        </div>
        <b>我的积分</b>
        <div class="tips">
          <span
            >现有积分：<i class="uc-blue">{{ model.remainder || 0 }}</i></span
          >
          <span
            >共消耗积分：<i class="uc-blue">{{ model.consume || 0 }}</i></span
          >
          <span
            >共获得积分：<i class="uc-blue">{{ model.total || 0 }}</i></span
          >
        </div>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入搜索关键字"
          class="uc-input"
          v-model="query.keyword"
        />
        <a href="javascript:;" class="uc-btn blue" @click="loadData"
          ><i class="uc-font uc-search"></i
        ></a>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="filter">
        <el-dropdown @command="handleCommand" class="uc-pl30">
          <span class="el-dropdown-link">
            {{ custom }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in dropDownData"
              :key="index"
              :command="{ value: item.val, label: item.label, type: item.type }"
              :divided="item.divided"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <router-link :to="{ name: 'Mall' }" class="link"
          >前往积分商城 >></router-link
        >
      </div>
      <div class="table">
        <table>
          <tr>
            <th style="width:10%;">序</th>
            <th style="width:40%;" class="left">来源</th>
            <th style="width:20%;">类型</th>
            <th style="width:20%;">时间</th>
            <th style="width:10%;">积分</th>
          </tr>
          <tr v-if="list.total_count == 0">
            <td colspan="10">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>

          <tr v-for="(item, index) in list.items" :key="index">
            <td>{{ item.row }}</td>
            <td class="left">{{ item.tenant_name }}</td>
            <td>{{ item.integral_rule.name }}</td>
            <td>{{ item.create_time }}</td>
            <td :class="item.score > 0 ? 'uc-red' : 'uc-green'">
              <b>{{ item.score > 0 ? '+' + item.score : item.score }}</b>
            </td>
          </tr>
        </table>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'PersonalIntegral',
  data() {
    return {
      query: {
        ruleId: -1,
        type: 0,
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      model: {},
      ruleList: [],
      list: [],

      dropDownData: [{ label: '全部', val: -1, type: 0, divided: false }],
      custom: '全部',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMyIngtegral();
      this.getIntegralDetails();
      this.getIntegralRules();
    },
    loadData() {
      this.getIntegralDetails();
    },
    handleCommand(command) {
      this.custom = command.label;
      this.query.ruleId = command.value;
      this.query.type = command.type;
      this.query.pageIndex = 1;
      this.loadData();
    },
    // 我的积分
    async getMyIngtegral() {
      const response = await this.$api.integral.getMyIngtegral();
      this.model = response.data.data || {};
    },
    // 积分规则
    async getIntegralRules() {
      const response = await this.$api.integral.getIntegralRules();
      let i = 0;
      for (const item of response.data.data) {
        if (item.type > 0) {
          i++;
        }
        this.dropDownData.push({
          label: item.name,
          val: item.id,
          type: item.type,
          divided: i === 1,
        });
        if (item.type === 0) {
          this.ruleList.push(item);
        }
      }
    },
    // 积分明细
    async getIntegralDetails() {
      const response = await this.$api.integral.getIntegralDetails(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
  },
};
</script>
